export const text = {
  STATE_INFORMATION: 'State information',
  PHONE_VISITS: 'Phone visits',
  DRUG_SCREENING: 'Drug screening',
  PATIENTS: 'Patients',
  CANNOT: 'cannot',
  BOOK_PHONE_VISITS: 'book phone visits',
  THIS_STATE_REQUIRES_DRUG_SCREENING: 'This state requires drug screening',
  YES: 'yes',
  NO: 'no',
  PLACEHOLDER: 'Begin typing here...',
} as const

export const switchContainerStyle = { marginLeft: 18 } as const
